module.exports = __webpack_public_path__ + "static/img/mrto.4fb6c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mrto.png
// module id = sTDC
// module chunks = 3